import {
  Wrench,
  Building2,
  Mail,
  Phone,
  Globe,
  ArrowRight,
} from "lucide-react";

import "./UnderConstruction.css";

import logo from "../assets/images/PTX_logo.png";
import background from "../assets/images/UnderConstruction_BG.png";

export default function UnderConstruction() {
  return (
    <section
      className="maintenance"
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      <div className="overlay"></div>

      <div className="maintenance-card">
        <img src={logo} alt="PTX Global" className="logo" />

        <div className="icon-circle">
          <Wrench size={42} />
        </div>

        <span className="badge">WEBSITE UNDER CONSTRUCTION</span>

        <h1>We're Building Something Better</h1>

        <p>
          Our new website is currently under construction as we prepare a
          faster, smarter and more modern digital experience for our clients and
          partners.
        </p>

        <div className="divider"></div>

        <div className="services">
          <div className="service">
            <Building2 size={18} />
            <span>Stressing Systems</span>
          </div>

          <div className="service">
            <Building2 size={18} />
            <span>Jacking Systems</span>
          </div>

          <div className="service">
            <Building2 size={18} />
            <span>Hydraulic Solutions</span>
          </div>

          {/* <div className="service">
            <Building2 size={18} />
            <span>Construction Technologies</span>
          </div> */}
        </div>

        <div className="buttons">
          <a href="mailto:raghav@ptxglobal.net" className="primary-btn">
            <Mail size={18} />
            Contact Us
            <ArrowRight size={18} />
          </a>

          {/* <a
            href="https://www.linkedin.com"
            target="_blank"
            rel="noreferrer"
            className="secondary-btn"
          >
            <ArrowRight size={18} />
            Follow Us
          </a> */}
        </div>

        <div className="contact">
          <div>
            <Phone size={18} />
            +91 97403 26890
          </div>

          <div>
            <Mail size={18} />
            raghav@ptxglobal.net
          </div>

          <div>
            <Globe size={18} />
            www.ptxglobal.net
          </div>
        </div>

        <div className="footer">
          Engineering Strength. Global Reach.
          <br />© 2026 PTX Global. All Rights Reserved.
        </div>
      </div>
    </section>
  );
}
